import type { FieldMatcher } from '@cdw-ae/filter-bar-interfaces';

export const OuTreePickerMatcher: FieldMatcher = {
  name: 'ouTreePicker',
  displayName: 'Select OU',
  hasEditor: true,
  options: {
    dialogWidth: '600px',
    toolTipFormatter: (value: string): string => {
      try {
        const parsed = JSON.parse(value);
        const exact: string[] = parsed.exact ?? [];
        const subtrees: string[] = parsed.subtrees ?? [];
        if (!(exact.length || subtrees.length)) return 'All OUs';
        const items = [
          ...exact,
          ...subtrees.map((s: string) => `${s} (+ all children)`),
        ];
        return items.join('\n') || '(none)';
      } catch {
        return value;
      }
    },
    chipFormatter: (value: string): string => {
      try {
        const parsed = JSON.parse(value);
        const firstItem = (parsed.exact?.[0] ?? parsed.subtrees?.[0]) as string | undefined;
        const total = (parsed.totalCount as number) ?? 0;
        if (!firstItem) return ': All OUs';
        if (total <= 1) return `: ${firstItem}`;
        return `: ${firstItem} + ${total - 1} more`;
      } catch {
        return `: ${value}`;
      }
    },
  },
};
